export default __webpack_public_path__ + "media/images/backgrounds/sunflower-bg-a727d7ed864f1544c689831d62cb7319.svg";